/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description flag modal reducer
 */

import { payloadKeyReducer } from '@zcode/reducers'
import type { FlagModal } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction } from 'redux-actions'
import { RECEIVE_DATA } from '../constants/flagModal'
import type { ActionTypes } from '../types'

export const flagReducer = combineReducers<FlagModal, ActionTypes>({
  analyticChannel: handleAction<FlagModal['analyticChannel'], ActionTypes, typeof RECEIVE_DATA>(
    RECEIVE_DATA,
    payloadKeyReducer('analyticChannel'),
    ''
  ),
  entity: handleAction<FlagModal['entity'], ActionTypes, typeof RECEIVE_DATA>(
    RECEIVE_DATA,
    payloadKeyReducer('entity'),
    null
  ),
})
